import React from "react";
import JsonViewer from "searchable-react-json-view";

// CSV Generator
import { ExportSftpLog } from "../Common/ExportSftpLog";

const LogDataShowElement = (props) => {
  const { SFTPLogData } = props;

  return (
    <div className="is_table_3">
      <ExportSftpLog style={{ "margin-top": "40px" }} logData={SFTPLogData} />
      <JsonViewer
        style={{ width: "100%", "margin-top": "23px" }}
        name="Log"
        sortKeys
        iconStyle="circle"
        displayObjectSize={false}
        src={SFTPLogData}
        enableClipboard={false}
        displayDataTypes={false}
        onEdit={false}
        collapsed
      />
    </div>
  );
};

export default LogDataShowElement;
